<template>
  <footer class="modern-footer">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-4">
          <div class="footer-brand">
            <a target="_blank" :href="$siteInstituto" class="brand-link">
              <img src="../assets/images/instituto.jpg" alt="Instituto" class="brand-logo" />
            </a>
          </div>
        </div>
        <div class="col-md-4">
          <div class="footer-contact">
            <h6 class="contact-title">Suporte</h6>
            <div class="contact-info">
              <a :href="`tel:${suporteTelefone}`" class="contact-item">
                <i class="fas fa-phone"></i>
                <span>{{ suporteTelefone }}</span>
              </a>
              <a :href="`mailto:${suporteEmail}`" class="contact-item">
                <i class="fas fa-envelope"></i>
                <span>{{ suporteEmail }}</span>
              </a>
            </div>
          </div>
        </div>
        <div class="col-md-4 text-md-end">
          <div class="footer-info">
            <span class="version-info">v.{{ pkg.version }}</span>
            <div class="footer-links">
              <a :href="$siteInstituto" target="_blank" class="footer-link">
                <i class="fas fa-external-link-alt me-1"></i>Site Oficial
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="row">
          <div class="col-12 text-center">
            <p class="copyright">
              © {{ currentYear }} Instituto Brasileiro de Ciências em Gestão Pública. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import pkg from '../../package.json'

export default {
  name: 'FooterComp',

  data() {
    return {
      pkg,
      suporteEmail: 'suporte@ibcgp.org.br',
      suporteTelefone: '(67) 3042-4800' // Atualize com o número correto
    }
  },

  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>
<style lang="sass" scoped>
.modern-footer
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%)
  color: white
  padding: 30px 0 20px
  margin-top: auto
  box-shadow: 0 -5px 15px rgba(0, 0, 0, 0.1)

.footer-brand
  display: flex
  align-items: center

.brand-link
  text-decoration: none
  transition: transform 0.3s ease

.brand-link:hover
  transform: scale(1.05)

.brand-logo
  width: 120px
  height: auto
  border-radius: 8px
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2)

.footer-contact
  text-align: center

  .contact-title
    font-size: 0.9rem
    font-weight: 600
    margin-bottom: 10px
    color: rgba(255, 255, 255, 0.9)
    text-transform: uppercase
    letter-spacing: 0.5px

  .contact-info
    display: flex
    flex-direction: column
    gap: 8px

  .contact-item
    color: rgba(255, 255, 255, 0.8)
    text-decoration: none
    font-size: 0.9rem
    display: flex
    align-items: center
    justify-content: center
    gap: 8px
    transition: color 0.3s ease
    padding: 4px 0

    i
      font-size: 0.85rem
      opacity: 0.8

    &:hover
      color: white
      text-decoration: none

      i
        opacity: 1

.footer-info
  display: flex
  flex-direction: column
  align-items: flex-end
  gap: 10px

.version-info
  background: rgba(255, 255, 255, 0.1)
  padding: 4px 12px
  border-radius: 15px
  font-size: 0.8rem
  font-weight: 500
  backdrop-filter: blur(10px)

.footer-links
  display: flex
  gap: 15px

.footer-link
  color: rgba(255, 255, 255, 0.8)
  text-decoration: none
  font-size: 0.9rem
  transition: color 0.3s ease
  display: flex
  align-items: center

.footer-link:hover
  color: white
  text-decoration: none

.footer-bottom
  margin-top: 20px
  padding-top: 20px
  border-top: 1px solid rgba(255, 255, 255, 0.1)

.copyright
  color: rgba(255, 255, 255, 0.7)
  font-size: 0.85rem
  margin: 0

/* Responsividade */
@media (max-width: 768px)
  .modern-footer
    padding: 25px 0 15px

  .footer-contact
    margin: 20px 0
    text-align: center

  .footer-info
    align-items: center
    margin-top: 15px

  .brand-logo
    width: 100px

  .footer-links
    justify-content: center

@media (max-width: 576px)
  .modern-footer
    padding: 20px 0 15px

  .brand-logo
    width: 90px

  .footer-contact
    margin: 15px 0

    .contact-info
      align-items: center

  .footer-info
    flex-direction: column
    align-items: center
    gap: 8px

  .footer-links
    flex-direction: column
    gap: 8px

  .copyright
    font-size: 0.8rem
    line-height: 1.4
</style>
